import React from "react";
import Section from "../components/Section";
import { BRAND } from "../config/brandConfig";

// Local styling for the form inputs (Keeping it local as per original design)
const inputStyle = {
  width: "100%",
  marginTop: "0.25rem",
  padding: "0.5rem 0.6rem",
  borderRadius: 10,
  border: "1px solid rgba(148,163,184,0.9)",
  fontSize: 13,
  fontFamily: "inherit",
  outline: "none",
};

function ContactPage() {
  return (
    <div>
      <Section
        eyebrow="Next step"
        // SAGE 4 (UBS) TITLE UPDATE
        title="Bring your complexity — let’s make it coherent."
        // SAGE 4 (UBS) KICKER UPDATE
        kicker="Start a confidential conversation about your full financial architecture and the planning strategies that matter most."
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "minmax(0, 1.1fr) minmax(0, 1fr)",
            gap: "2rem",
          }}
        >
          <form
            style={{
              display: "grid",
              gap: "0.75rem",
              backgroundColor: "#ffffff",
              borderRadius: 16,
              padding: "1.5rem",
              border: "1px solid rgba(148,163,184,0.5)",
            }}
          >
            <label style={{ fontSize: 13 }}>
              Name
              <input
                type="text"
                placeholder="Your full name"
                style={inputStyle}
              />
            </label>
            <label style={{ fontSize: 13 }}>
              Email
              <input
                type="email"
                placeholder="you@example.com"
                style={inputStyle}
              />
            </label>
            <label style={{ fontSize: 13 }}>
              Approximate investable assets
              <select style={inputStyle}>
                <option value="">Select a range</option>
                <option>$1M–$3M</option>
                <option>$3M–$10M</option>
                <option>$10M+</option>
              </select>
            </label>
            <label style={{ fontSize: 13 }}>
              What would you like to discuss?
              <textarea
                rows={4}
                placeholder="Briefly describe your situation or goals..."
                style={{ ...inputStyle, resize: "vertical" }}
              />
            </label>
            <button
              type="submit"
              style={{
                marginTop: "0.5rem",
                border: "none",
                outline: "none",
                cursor: "pointer",
                borderRadius: 999,
                padding: "0.6rem 1.25rem",
                background: `linear-gradient(135deg, ${BRAND.accent}, #1e6091)`,
                color: "white",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Submit inquiry
            </button>
          </form>

          <div style={{ fontSize: 14, color: "#475569" }}>
            <p>
              Your dev can plug this form into whatever backend or CRM your
              friend uses (HubSpot, Salesforce, simple email handler, etc.).
            </p>
            <p>
              You might also later add calendar integration (Calendly, SavvyCal)
              so prospective clients can pick a time directly that works for
              them.
            </p>
          </div>
        </div>
      </Section>
    </div>
  );
}

export default ContactPage;
